<ng-container style="height:100%;width:100%;">
	<wa-page style="height:100%;width:100%;">
		<header slot="header">
			<div class="wrapper-nav-products">
				<nav aria-label="DevSuite Products" class="nav-products nav-products-full">
					<div class="nav-products-primary wa-split wa-align-items-stretch">
						<div class="wa-cluster wa-align-items-stretch wa-gap-0">
							<a aria-label="JWebMP" class="product product-jwebmp product-active appearance-plain" routerLink="/home">
								<i class="fak fa-jwebmp-logo-green logo-icon logo-jwebmp"></i>
								<span class="logo-jwebmp-text"></span>
							</a>
							<a class="product product-guicedee appearance-plain" href="https://guicedee.com" id="product-guicedee" target="_blank">
								<i class="fak fa-guicedee-logo logo-icon logo-guicedee"></i>
							</a>
							<wa-tooltip for="product-guicedee">GuicedEE</wa-tooltip>
							<a class="product product-entity-assist appearance-plain" href="https://entityassist.com" id="product-entity-assist" target="_blank">
								<wa-icon class="logo-icon logo-entity-assist" name="database"></wa-icon>
							</a>
							<wa-tooltip for="product-entity-assist">Entity Assist</wa-tooltip>
							<a class="product product-activity-master appearance-plain" href="https://github.com/Activity-Master/" id="product-activity-master" target="_blank">
								<wa-icon class="logo-icon logo-activity-master" name="tasks"></wa-icon>
							</a>
							<wa-tooltip for="product-activity-master">Activity Master</wa-tooltip>
							<wa-badge class="version-badge" id="snapshot-badge" pill style="background-color: var(--wa-color-brand-normal);color: var(--wa-color-brand-on-normal);cursor: pointer;font-size:var(--wa-font-size-2xs);" variant="brand">2.0.0-SNAPSHOT</wa-badge>
							<wa-popover for="snapshot-badge" id="jw638d67" placement="bottom" style="--arrow-color:var(--wa-color-brand-normal);--border-color:var(--wa-color-brand-normal);--border-radius:var(--wa-border-radius-l);--border-width:var(--wa-border-width-s);--max-width:32rem;">
								<div style="padding: var(--wa-spacing-medium);">
									<strong style="display:block;font-size:var(--wa-font-size-m);margin-bottom:var(--wa-spacing-small);">Snapshot Repository Setup</strong>
									<p [innerText]="useGradle ? 'Add to your build.gradle:' : 'Add to your pom.xml:'" style="color:var(--wa-color-neutral-700);font-size:var(--wa-font-size-s);margin:0 0 var(--wa-spacing-small) 0;"></p>
									<markdown *ngIf="!useGradle" [data]="mdContent_0" class="aside-snippet-code wa-body-xs" clipboard></markdown>
									<markdown *ngIf="useGradle" [data]="mdContent_1" class="aside-snippet-code wa-body-xs" clipboard></markdown>
									<p style="color:var(--wa-color-neutral-600);font-size:var(--wa-font-size-2xs);margin:var(--wa-spacing-small) 0 0 0;">&#x1F511; GitHub Packages requires authentication — use a personal access token with <code>read:packages</code> scope.</p>
								</div>
							</wa-popover>
						</div>
						<div class="nav-products-secondary wa-cluster wa-gap-2xs">
							<div class="wa-cluster wa-gap-2xs wa-align-items-center" style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">
								<span>Maven</span>
								<wa-switch (ngModelChange)="onBuildToolChange($event)" [(ngModel)]="useGradle" name="com_jwebmp_webawesome_components_waswitch_WaSwitch" size="small"></wa-switch>
								<span>Gradle</span>
							</div>
							<wa-button appearance="plain" class="pseudo-product product-github" href="https://github.com/GedMarc/JWebMP" id="product-github" target="_blank" variant="brand">
								<wa-icon family="brands" label="GitHub" name="github"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-github">GitHub</wa-tooltip>
							<wa-button appearance="plain" class="pseudo-product product-star" href="https://github.com/GedMarc/JWebMP/stargazers" id="product-star" target="_blank" variant="brand">
								<wa-icon label="Star this Repository" name="star"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-star">Star this Repository</wa-tooltip>
							<wa-button appearance="plain" class="pseudo-product product-docs" href="https://github.com/GuicedEE/ai-rules" id="product-docs" target="_blank" variant="brand">
								<wa-icon label="AI Skills Repository" name="brain-circuit"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-docs">AI Skills Repository</wa-tooltip>
							<wa-button (click)="toggleDarkMode()" appearance="plain" class="pseudo-product product-theme" id="product-theme" variant="brand">
								<wa-icon [name]="darkMode() ? 'sun-bright' : 'moon'" label="Toggle Theme" name="com_jwebmp_webawesome_components_icon_WaIcon"></wa-icon>
							</wa-button>
							<wa-tooltip for="product-theme">Toggle Theme</wa-tooltip>
						</div>
					</div>
				</nav>
			</div>
		</header>
		<div slot="menu">
			<wa-tree style="--indent-guide-color:var(--wa-color-neutral-300);--indent-size:2px;">
				<wa-tree-item>
					<a href="#" routerLink="/home">
						<wa-icon class="wa-gap-1" name="house" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Home
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/about">
						<wa-icon class="wa-gap-1" name="circle-info" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;About
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/getting-started">
						<wa-icon class="wa-gap-1" name="rocket" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Getting Started
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/architecture">
						<wa-icon class="wa-gap-1" name="sitemap" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Architecture
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/stack">&nbsp;Stack Diagram</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/build-pipeline">&nbsp;Build Pipeline</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/runtime">&nbsp;Runtime</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/data-flow">&nbsp;Data Flow</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/module-graph">&nbsp;Module Graph</a>
					</wa-tree-item>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/plugins">
						<wa-icon class="wa-gap-1" name="puzzle-piece" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Plugins
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Rendering & UI</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/core">&nbsp;JWebMP Core</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/client">&nbsp;JWebMP Client</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/web-awesome">&nbsp;WebAwesome</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/web-awesome-pro">&nbsp;WebAwesome Pro</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Angular Generation</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/angular">&nbsp;Angular Plugin</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/angular-maven-plugin">&nbsp;Angular Maven Plugin</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/typescript-client">&nbsp;TypeScript Client</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Data & Grids</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/aggrid">&nbsp;AG Grid</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/aggrid-enterprise">&nbsp;AG Grid Enterprise</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Charts & Visualisation</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/agcharts">&nbsp;AG Charts</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/agcharts-enterprise">&nbsp;AG Charts Enterprise</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/chartjs">&nbsp;Chart.js</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Scheduling</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/fullcalendar">&nbsp;FullCalendar</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/fullcalendar-pro">&nbsp;FullCalendar Pro</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Icons</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/fontawesome">&nbsp;Font Awesome</a>
						</wa-tree-item>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/fontawesome-pro">&nbsp;Font Awesome Pro</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Animation</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/easing">&nbsp;Easing Effects</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Real-Time Messaging</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/rabbitmq">&nbsp;RabbitMQ Comms</a>
						</wa-tree-item>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins">&nbsp;Runtime & Server</a>
						<wa-tree-item>
							<a href="#" routerLink="/plugins/vertx">&nbsp;JWebMP Vert.x</a>
						</wa-tree-item>
					</wa-tree-item>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/capabilities">
						<wa-icon class="wa-gap-1" name="star" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Capabilities
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/rendering">&nbsp;Rendering</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/angular-generation">&nbsp;Angular Generation</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/event-system">&nbsp;Event System</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/real-time-messaging">&nbsp;Real-Time Messaging</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/plugin-model">&nbsp;Plugin Model</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/spi-extensibility">&nbsp;SPI Extensibility</a>
					</wa-tree-item>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/real-time">
						<wa-icon class="wa-gap-1" name="bolt" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Data
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/communication-layers">&nbsp;Communication Layers</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/rest-and-ajax">&nbsp;REST & AJAX</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/data-services">&nbsp;Data Services</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/vertx-event-bus">&nbsp;Vert.x Event Bus</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/vertx-code-samples">&nbsp;Vert.x Code Samples</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/rabbitmq">&nbsp;RabbitMQ</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/rabbitmq-code-samples">&nbsp;RabbitMQ Code Samples</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/choosing-a-pattern">&nbsp;Choosing a Pattern</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/use-cases">&nbsp;Use Cases</a>
					</wa-tree-item>
				</wa-tree-item>
			</wa-tree>
		</div>
		<div slot="navigation-toggle">
			<wa-button appearance="plain" aria-label="Toggle navigation menu" variant="neutral">
				<wa-icon name="bars"></wa-icon>
			</wa-button>
		</div>
		<div slot="navigation-toggle-icon">
			<wa-icon name="bars"></wa-icon>
		</div>
		<nav slot="navigation-header">
			<a aria-label="JWebMP Home" class="appearance-plain" routerLink="/home">
				<i class="fak fa-jwebmp-logo-green logo-icon logo-jwebmp"></i>
			</a>
		</nav>
		<nav slot="navigation">
			<wa-tree style="--indent-guide-color:var(--wa-color-neutral-300);--indent-size:2px;">
				<wa-tree-item>
					<a href="#" routerLink="/home">
						<wa-icon class="wa-gap-1" name="house" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Home
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/about">
						<wa-icon class="wa-gap-1" name="circle-info" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;About
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/getting-started">
						<wa-icon class="wa-gap-1" name="rocket" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Getting Started
					</a>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/architecture">
						<wa-icon class="wa-gap-1" name="sitemap" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Architecture
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/stack">&nbsp;Stack Diagram</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/build-pipeline">&nbsp;Build Pipeline</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/runtime">&nbsp;Runtime</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/data-flow">&nbsp;Data Flow</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/architecture/module-graph">&nbsp;Module Graph</a>
					</wa-tree-item>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/plugins">
						<wa-icon class="wa-gap-1" name="puzzle-piece" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Plugins
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/core">&nbsp;JWebMP Core</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/client">&nbsp;JWebMP Client</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/web-awesome">&nbsp;WebAwesome</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/web-awesome-pro">&nbsp;WebAwesome Pro</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/angular">&nbsp;Angular Plugin</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/angular-maven-plugin">&nbsp;Angular Maven Plugin</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/typescript-client">&nbsp;TypeScript Client</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/aggrid">&nbsp;AG Grid</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/aggrid-enterprise">&nbsp;AG Grid Enterprise</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/agcharts">&nbsp;AG Charts</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/agcharts-enterprise">&nbsp;AG Charts Enterprise</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/chartjs">&nbsp;Chart.js</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/fullcalendar">&nbsp;FullCalendar</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/fullcalendar-pro">&nbsp;FullCalendar Pro</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/fontawesome">&nbsp;Font Awesome</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/fontawesome-pro">&nbsp;Font Awesome Pro</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/easing">&nbsp;Easing Effects</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/rabbitmq">&nbsp;RabbitMQ Comms</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/plugins/vertx">&nbsp;JWebMP Vert.x</a>
					</wa-tree-item>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/capabilities">
						<wa-icon class="wa-gap-1" name="star" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Capabilities
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/rendering">&nbsp;Rendering</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/angular-generation">&nbsp;Angular Generation</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/event-system">&nbsp;Event System</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/real-time-messaging">&nbsp;Real-Time Messaging</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/plugin-model">&nbsp;Plugin Model</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/capabilities/spi-extensibility">&nbsp;SPI Extensibility</a>
					</wa-tree-item>
				</wa-tree-item>
				<wa-tree-item>
					<a href="#" routerLink="/real-time">
						<wa-icon class="wa-gap-1" name="bolt" style="color: var(--wa-color-brand-on-normal);"></wa-icon>&nbsp;Data
					</a>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/communication-layers">&nbsp;Communication Layers</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/rest-and-ajax">&nbsp;REST & AJAX</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/data-services">&nbsp;Data Services</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/vertx-event-bus">&nbsp;Vert.x Event Bus</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/vertx-code-samples">&nbsp;Vert.x Code Samples</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/rabbitmq">&nbsp;RabbitMQ</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/rabbitmq-code-samples">&nbsp;RabbitMQ Code Samples</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/choosing-a-pattern">&nbsp;Choosing a Pattern</a>
					</wa-tree-item>
					<wa-tree-item>
						<a href="#" routerLink="/real-time/use-cases">&nbsp;Use Cases</a>
					</wa-tree-item>
				</wa-tree-item>
			</wa-tree>
		</nav>
		<nav slot="navigation-footer">
			<a href="https://github.com/GedMarc/JWebMP" target="_blank">GitHub
				<wa-icon family="brands" name="github"></wa-icon>
			</a>
			<a href="https://guicedee.com" target="_blank">GuicedEE
				<wa-icon name="cubes"></wa-icon>
			</a>
		</nav>
		<main class="wa-body-l">
			<router-outlet></router-outlet>
		</main>
		<div slot="aside">
			<router-outlet name="aside"></router-outlet>
		</div>
	</wa-page>
</ng-container>